import Vue from 'vue';

export const applyDialogBus = new Vue();

export function openApplyDialog(payload = {}) {
  applyDialogBus.$emit('open', payload);
}
